import { getContext, setContext } from "svelte"

const fetchErrorHandlerContextName = "fetchErrorHandler"

/**
 *
 * @returns {{
 *   handleFetchErrors: (fetchError: FetchError) => void,
 *   handleNonBlockingFetchErrors: (fetchError: FetchError) => void,
 * }}
 */
export function getFetchErrorHandlerContext() {
  return getContext(fetchErrorHandlerContextName)
}

export function setFetchErrorHandlerContext(value) {
  return setContext(fetchErrorHandlerContextName, value)
}
